/* eslint-disable global-require,import/no-unresolved,max-len, react/forbid-prop-types, react/jsx-no-bind, react/no-array-index-key, react/no-string-refs */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
 Dimensions, Image, ScrollView, View,
} from 'react-native'
import { withTranslation } from 'react-i18next'
import styles, { colors } from '../../styles'
import panelStyles from '../../styles/panel'

class LightStageDetails extends Component {
  onLayout(e) {
    const { nativeEvent: { layout: { height } } } = e
    this.height = height
    this.forceUpdate()
  }

  render() {
    const { height: heightOfDeviceScreen } = Dimensions.get('window')
    const {
      analyticsEvent,
      sourceImage,
      sourceImageStyle,
      accessibilityLabel,
      children,
    } = this.props

    return (
      <View testID={`safeview-${analyticsEvent}`} style={{ flex: 1, backgroundColor: colors.bscBlue }}>
        <View testID={`view-${analyticsEvent}`} style={{ flex: 1 }}>
          <ScrollView
            contentContainerStyle={{ minHeight: this.height || heightOfDeviceScreen }}
            onLayout={this.onLayout.bind(this)}
            style={{ backgroundColor: colors.white, flexGrow: 1 }}
            testID={`scrollview-${analyticsEvent}`}
          >
            <View style={styles.lightStageContainer}>
              <Image
                style={[panelStyles.lightImage, styles.textMargin, sourceImageStyle]}
                source={sourceImage}
                accessibilityLabel={accessibilityLabel}
              />
              {children}
            </View>
          </ScrollView>
        </View>
      </View>
    )
  }
}

LightStageDetails.defaultProps = {
  sourceImageStyle: null,
}
LightStageDetails.propTypes = {
  analyticsEvent: PropTypes.string.isRequired,
  sourceImageStyle: PropTypes.object,
  sourceImage: PropTypes.number.isRequired,
  accessibilityLabel: PropTypes.string.isRequired,
  children: PropTypes.instanceOf(Array).isRequired,
}

export default withTranslation(['indicatorLights', 'common'])(LightStageDetails)
